/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2020-08-03 10:04:56
 * @LastEditors: snzo.chen
 * @LastEditTime: 2023-12-06 12:41:19
 */
import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';

export const API_CONFIG_HOME = new InjectionToken('AppConfigToken');
export const API_CONFIG_ADMIN = new InjectionToken('AppConfigAdminToken');
export const API_CONFIG_UNION = new InjectionToken('AppConfigUnionToken');
export const API_CONFIG_KNOWLEDGE = new InjectionToken(
  'AppConfigKnowledgeToken'
);
@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    // { provide: API_CONFIG_ADMIN, useValue: '/snzoxgw' },
    // { provide: API_CONFIG_HOME, useValue: 'http://192.168.100.27:8086/snzoxgw' },
    {
      provide: API_CONFIG_ADMIN,
      useValue: 'http://test.cqesa.com:8086/snzoxgw',
    },
    {
      provide: API_CONFIG_HOME,
      useValue: 'http://test.cqesa.com:8086/snzoxgw',
    },
    { provide: API_CONFIG_KNOWLEDGE, useValue: 'https://contest.snzo.cn/' },
    { provide: API_CONFIG_UNION, useValue: 'https://www.cqesa.com' },
  ],
})
export class ServicesModule {}
